var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-image-preview',{attrs:{"images":_vm.data,"closeable":true,"startPosition":_vm.startPosition},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}})}
var staticRenderFns = []

export { render, staticRenderFns }